import type { T_SwapDirection } from '../../../hooks/PoolsToken/usePoolsTokenSwap';

interface I_ValidateBalanceProps {
  isFullyConnected: boolean;
  inputAmountBigInt: bigint | undefined;
  swapDirection: T_SwapDirection;
  usdcBalance: bigint | undefined;
  tokenBalance: bigint | undefined;
  actualTokenDecimals: number;
  tokenDecimals: number;
}

export function validateBalance({
  isFullyConnected,
  inputAmountBigInt,
  swapDirection,
  usdcBalance,
  tokenBalance,
  actualTokenDecimals,
  tokenDecimals
}: I_ValidateBalanceProps): boolean {
  if (!isFullyConnected || !inputAmountBigInt) return false;

  if (swapDirection === 'usdc-to-token') {
    if (!usdcBalance) return false;
    return usdcBalance < inputAmountBigInt;
  } else {
    if (!tokenBalance) return false;
    if (actualTokenDecimals === tokenDecimals) {
      return tokenBalance < inputAmountBigInt;
    } else if (actualTokenDecimals > tokenDecimals) {
      const inputInActualDecimals =
        inputAmountBigInt * BigInt(10 ** (actualTokenDecimals - tokenDecimals));
      return tokenBalance < inputInActualDecimals;
    } else {
      const inputInActualDecimals =
        inputAmountBigInt / BigInt(10 ** (tokenDecimals - actualTokenDecimals));
      return tokenBalance < inputInActualDecimals;
    }
  }
}
